export default __webpack_public_path__ + "static/media/homeSweet.1aac05a5.jpg";